import axios from 'axios'

/**
 * BGG XML API2 — use apex host (www returns 301; auth may not survive redirect the same way).
 * As of 2025, requests need Authorization: Bearer <token> from a registered app.
 * @see https://boardgamegeek.com/using_the_xml_api
 */
export const BGG_XMLAPI2_BASE = 'https://boardgamegeek.com/xmlapi2'

export const bggHttp = axios.create({
	baseURL: BGG_XMLAPI2_BASE,
})

bggHttp.interceptors.response.use(
	(response) => {
		if (response.status === 202) {
			return Promise.reject(new axios.Cancel('Waiting for collection'))
		}
		return response
	},
	(error) => Promise.reject(error)
)

bggHttp.interceptors.request.use((config) => {
	const token = process.env.REACT_APP_BGG_API_TOKEN
	if (token && String(token).trim()) {
		config.headers = config.headers || {}
		config.headers.Authorization = `Bearer ${String(token).trim()}`
	}
	return config
})

export function hasBggApiToken() {
	const token = process.env.REACT_APP_BGG_API_TOKEN
	return Boolean(token && String(token).trim())
}
